var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-card',{attrs:{"name":"audience.driving_behavior","rounded":"","error":_vm.error}},[_c('score-collection',{attrs:{"values":_vm.values}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }